import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';

import OverlayInput from '../containers/OverlayInput';

class Overlay extends Component {
  // eslint-disable-next-line no-undef
  handleClickOutside = () => {
    this.props.input.props.overlayProps.hide();
  };

  render() {
    const { children, onFocus, onBlur, input } = this.props;
    const {
      component,
      iconSize,
      range,
      addClearBtn,
      from,
      to,
      selectPreset,
      selectFrom,
      selectTo,
      clearValue,
      presets,
    } = input.props.overlayProps;

    return (
      <div
        className={classnames(
          'c-date-picker-wrapper',
          { 'u--ml': component === 'button',
            'u--ml-': component === 'button' && iconSize === 'medium' }
        )}
        onFocus={onFocus}
        onBlur={onBlur}
        tabIndex="0"
      >
        <div className={classnames('c-date-picker', { 'c-date-picker--range': range && presets.length })}>

          <div className="c-date-picker__calendar" tabIndex="0">
            {children}
          </div>

          {range && presets.map(preset => (
            <button
              key={preset.id}
              className="c-date-picker__preset-button"
              type="button"
              onClick={selectPreset(preset.id)}
            >
              {preset.label}
            </button>
          ))}

          <form className="c-date-picker__range-inputs" display-if={range}>
            <OverlayInput
              value={from}
              label="Start"
              onChange={selectFrom}
              onEnterPressed={this.props.input.props.overlayProps.hide}
              autoFocus
            />
            <OverlayInput
              value={to}
              label="End"
              onChange={selectTo}
              onEnterPressed={this.props.input.props.overlayProps.hide}
            />
          </form>

          <button
            display-if={addClearBtn}
            className="c-date-picker__clear-button c-btn c-btn--outline c-btn--outline-grey c-btn--small"
            type="button"
            onClick={clearValue}
          >
            Clear
          </button>

        </div>
      </div>
    );
  }
}

Overlay.propTypes = {
  children: PropTypes.node.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  input: PropTypes.shape({
    props: PropTypes.shape({
      overlayProps: PropTypes.object,
    }).isRequired,
  }).isRequired,
};

export default onClickOutside(Overlay);
